/* Templo Cosmética: página «suscripción confirmada» con nuestro estilo (02/11/2026, tema_suscripcion.py).
   Shopify pinta esa página él mismo (h1 con el nombre de la tienda, «Gracias por suscribirte a nuestra lista
   de distribución…» y el enlace «Darse de baja») y no hay plantilla que editar. Este script la reconoce por el
   texto y la cambia por una tarjeta con nuestro diseño, manteniendo el enlace de baja que manda Shopify. */
(() => {
  const iniciar = () => {
    const main = document.getElementById('MainContent');
    if (!main || !/Gracias por suscribirte a nuestra lista/i.test(main.textContent)) return;
    const h1 = main.querySelector('h1');
    const baja = [...main.querySelectorAll('a')].find((a) => /baja/i.test(a.textContent));
    const caja = h1 ? h1.parentElement : main;
    const enlaceBaja = baja ? baja.getAttribute('href') : '';
    caja.classList.add('templo-suscrito');
    caja.innerHTML = `
      <div class="templo-suscrito__tarjeta">
        <span class="templo-suscrito__icono" aria-hidden="true">
          <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M7 14h34v22a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3z"/><path d="M7 15l17 12 17-12"/><circle cx="37" cy="12" r="7" fill="#c8507a" stroke="#fff"/><path d="M34 12l2 2 4-4" stroke="#fff" stroke-width="2"/></svg>
        </span>
        <p class="templo-suscrito__etiqueta">Suscripción confirmada</p>
        <h1 class="templo-suscrito__titulo">¡Ya formas parte de Templo Cosmética!</h1>
        <p class="templo-suscrito__texto">Gracias por confirmar tu correo. A partir de ahora te contaremos antes que a nadie las novedades, lo más pedido y nuestras ofertas.</p>
        <div class="templo-suscrito__botones">
          <a class="templo-suscrito__boton" href="/collections/mas-vendidos">Ver lo más vendido</a>
          <a class="templo-suscrito__boton templo-suscrito__boton--borde" href="https://www.instagram.com/templo.cosmetica/" target="_blank" rel="noopener">Síguenos en Instagram</a>
        </div>
        ${enlaceBaja ? `<p class="templo-suscrito__baja">Puedes darte de baja cuando quieras: <a href="${enlaceBaja.replace(/"/g, '&quot;')}">darse de baja</a></p>` : ''}
      </div>`;
    document.title = 'Suscripción confirmada | Templo Cosmética';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
